const styles = {
  content: {
    background: '#FAFAFA',
    borderRadius: '8px',
  },
  imageBox: {
    display: 'flex',
    justifyContent: 'end',
  },
  image: {
    borderRadius: '8px',
    '@media only screen and (max-width: 1300px)': {
      width: '100%',
    },
    height: '100%',
    objectFit: 'cover',
  },
  textArea: {
    padding: '28px',
    color: '#000',
  },
  text: {
    fontWeight: '500',
    fontSize: '16px',
    '@media only screen and (max-width: 598px)': {
      fontSize: '14px',
    },
  },
  title: {
    color: '#000',
    marginTop: '5px',
    fontWeight: '700',
    fontSize: '20px',
    '@media only screen and (max-width: 598px)': {
      fontSize: '18px',
    },
  },
  button: {
    marginRight: '10px',
    padding: '4px 20px',
    fontSize: '14px',
  },
  buttonRg: {
    fontSize: '14px',
    padding: '4px 20px',
    background: '#fff',
    border: '1px solid #D1EDE8',
  },
  btnContent: {
    display: 'flex',
    marginTop: '14px',
  },
};

export default styles;
